/*
 * WhatsApp, the free way: a link that opens WhatsApp on the sender's own phone
 * with the message already written, addressed to the person. They press send
 * themselves, so there is no account, no approval and no charge per message.
 */

/** +237 6XX XX XX XX in the digits-only form wa.me wants, or null. */
export const whatsappNumber = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  if (/^[26]\d{8}$/.test(digits)) return `237${digits}`;
  if (digits.length >= 8 && digits.length <= 15) return digits.replace(/^00/, '');
  return null;
};

/** A wa.me link with the text filled in, or null when there is no usable number. */
export const whatsappLink = (phone, text = '') => {
  const number = whatsappNumber(phone);
  if (!number) return null;
  return `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
};
